import { sendToApi } from 'api/client'

export interface UpdateSubscriptionParams {
  payment_method_id?: string
  should_end_trial?: boolean
  price_id: string
}

export const VirtualMarketerClient = {
  updateSubscription: async (workspaceId: number, params: UpdateSubscriptionParams) => {
    return sendToApi(`/w/${workspaceId}/virtual_marketers/update_subscription`, {
      body: params,
      method: 'PUT',
    })
  },
}
